﻿import * as $ from 'jquery';
import { IEventAggregator } from 'common/barrels/core';
import { IDialog, IDialogOptions } from 'runtime/dialogs/dialog';
import { WorkItemInfo } from 'runtime/data/workiteminfo';
import { format } from 'common/functions/string';
import { IResourceProvider } from 'common/resourceprovider';
import { ForceCancelClaimRequested } from 'runtime/events/workitem/forcecancelclaimrequested';
import { CancelClaimRequested } from 'runtime/events/workitem/cancelclaimrequested';

export class CancelClaimDialog implements IDialog {
    options: IDialogOptions;
    private vm: CancelClaimVm;
    private dialogContent: JQuery;

    constructor(isForceCancel: boolean, ea: IEventAggregator, workItemInfo: WorkItemInfo, resources: IResourceProvider) {
        var vm = this.vm = new CancelClaimVm(isForceCancel, ea, workItemInfo, () => this.close());
        
        var titleFormat = resources.getCoreString('MsgCancelWorkItem');

        this.options = {
            title: format(titleFormat, workItemInfo.title),
            width: 520,
            dialogClass: 'wf-container wf-worktray-item-dialog',
            buttons: [
                { text: resources.getCoreString('XamlProceed'), click: vm.proceed.bind(vm) },
                { text: resources.getCoreString('XamlClose'), click: () => this.close() }
            ]
        };
        this.dialogContent = this.buildContent(workItemInfo, resources);
    }

    content(): JQuery {
        return this.dialogContent;
    }

    close(): void {
        this.dialogContent.dialog('close');
    }

    private buildContent(workItemInfo: WorkItemInfo, resources: IResourceProvider) : JQuery {
        return $('<div />').append([
            $('<div />').addClass('form-group').append([
                $('<label />').addClass('control-label').text(resources.getCoreString('XamlTitle')),
                $('<span />').addClass('form-control-static').text(workItemInfo.title)
            ]),
            $('<div />').addClass('form-group').append([
                $('<label />').addClass('control-label').text(resources.getCoreString('XamlType')),
                $('<span />').addClass('form-control-static').text(workItemInfo.definitionTitle)
            ]),
            $('<div />').addClass('form-group').append([
                $('<label />').addClass('control-label').text(resources.getCoreString('XamlStep')),
                $('<span />').addClass('form-control-static').text(workItemInfo.stepName)
            ]),
            $('<div />').addClass('form-group').append([
                $('<label />').addClass('control-label').text(resources.getCoreString('XamlClaimedBy')),
                $('<span />').addClass('form-control-static').text(workItemInfo.claimUserInfo.displayName)
            ]),
            $('<div />').addClass('form-group').append($('<span />').text(resources.getCoreString('XamlCancelClaimDialogMessage')))
        ]);
    }
}

class CancelClaimVm {
    constructor(private isForceCancel: boolean, private ea: IEventAggregator, private workItemInfo: WorkItemInfo, private completionAction: () => void) {
        this.isForceCancel = isForceCancel;
        this.ea = ea;
        this.workItemInfo = workItemInfo;
    }

    proceed(): void {
        var event = this.isForceCancel
            ? new ForceCancelClaimRequested(this.workItemInfo, this.completionAction)
            : new CancelClaimRequested(this.workItemInfo, this.completionAction);

        this.ea.publish(event);
    }
}